(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }
    if (typeof sm.portal.vm.ukbasicContact === "undefined") {
        jQuery.extend(sm.portal.vm, { ukbasicContact: {} });
    }

    function LoadModel(basicContact, container){
        basicContact.PermanentMailingAddress(new sm.portal.vm.MailingAddressViewModel());
        basicContact.PermanentMailingAddress().setType('permanent');
        basicContact.PrimaryMailingAddress().setType('correspondence');
        basicContact.PermanentMailingAddress().LoadModel(container);

        // apply contry name change subscriptions
        jQuery.each([basicContact.PrimaryMailingAddress()], function (k, control) {
            // subscribe to the control
            control.SelectedCountryID.subscribe(function () {
                // set the default address format is if there is one   
                control.SelectedTemplateID(basicContact.getDefaultAddressFormatId(control));
            }, this);
        });

        // subscribe to correspondence address checkbox
        basicContact.PrimaryMailingAddress().useMailingAddress.subscribe(function(checked) {
            basicContact.showPermanentMailingAddress(!checked);

            if (!checked) {
                jQuery.each([basicContact.PermanentMailingAddress()], function(k, control) {
                    // subscribe to the control
                    control.SelectedCountryID.subscribe(function() {
                        // set the default address format is if there is one   
                        control.SelectedTemplateID(basicContact.getDefaultAddressFormatId(control));
                    }, this);
                });

                if (basicContact.PermanentMailingAddress().SelectedCountryID() == undefined || basicContact.PermanentMailingAddress().SelectedCountryID() == null) {
                    basicContact.PermanentMailingAddress().SelectedCountryID(basicContact.PrimaryMailingAddress().SystemCountry().ID());
                }

                if (container.Payload.BasicContactPrep != null) {
                    basicContact.PermanentMailingAddress().AddressGID(container.Payload.BasicContactPrep.PermanentAddressGID);
                }
            } 
        });

        if (container.Payload.BasicContact != null) {
            if (!sm.portal.utility.isNullOrEmpty(container.Payload.BasicContact.PermanentMailingAddress)) {
                // load permanent address
                basicContact.PermanentMailingAddress().LoadAddressModel(container.Payload.BasicContact.PermanentMailingAddress);
                basicContact.PermanentMailingAddress().SelectedCountryID(container.Payload.BasicContact.PermanentMailingAddress.CountryID);
                if (!sm.portal.utility.isNullOrEmpty(container.Payload.BasicContact.PermanentMailingAddress.MailingAddressTemplateID)) {
                    basicContact.PermanentMailingAddress().SelectedTemplateID(container.Payload.BasicContact.PermanentMailingAddress.MailingAddressTemplateID);
                }

                // load permanent address contry template
                basicContact.selectCountryTemplate(
                    basicContact.PermanentMailingAddress(),
                    container.Payload.BasicContact.PermanentMailingAddress.MailingAddressTemplateID
                );
            }
            basicContact.PrimaryMailingAddress().useMailingAddress(sm.portal.utility.isNullOrEmpty(container.Payload.BasicContact.PermanentMailingAddress));
        }
        
    }

    function ShredValidation (basicContact, item) {
        var shared = {
            PrimaryPhoneNumber: {
                required: {
                    params: true,
                    message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
                },
                pattern: {
                    params: /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i,
                    message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), '##########')
                },
                maxLength: {
                    params: 20,
                    message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
                }
            },
            PrimaryEmailAddress: {
                required: {
                    params: true,
                    message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
                },
                email: {
                    message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'Example@domain.com')
                },
                maxLength: {
                    params: 250,
                    message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '250')
                }
            }
            /////// Validation will be applied in 1.8 release
            //validation: {
            //    validator: function (val) {
            //        var url = _baseApiUri + 'api/studentportal/DuplicatedEmail?email='+val;
            //        var duplicatedEmail = jQuery.ajax({
            //            url: url,
            //            type: 'GET',
            //            async: false,
            //            dataType: 'html',
            //            contentType: 'application/json; charset=utf-8',
            //            success: function (data, textStatus, jqXHR) {
            //                return data;
            //            }
            //        });

            //        if (duplicatedEmail.responseText == "true")
            //            return false;

            //        return true;
            //    },
            //    message: sm.portal.utility.getResourceValue(smapi.constant.validate_DuplicateEmail_Key)
            //}
        };

        return shared[item];
    };

    function ExtractATO(basicContact, returnObject){
        var stdPermanentAddress = null;

        if (basicContact.PermanentMailingAddress != undefined && basicContact.PermanentMailingAddress != null) {
            stdPermanentAddress = basicContact.PermanentMailingAddress().ExtractATO();
        }

        returnObject.PermanentAddress = stdPermanentAddress;
    }

    function Completed(basicContact){
        if ( basicContact.showPermanentMailingAddress() && !basicContact.PermanentMailingAddress().IsVMValid()){
            return false;
        }
        return true;
    }

    jQuery.extend(true, sm.portal.vm.ukbasicContact, {
        LoadModel: LoadModel,
        ExtractATO: ExtractATO,
        Completed: Completed,
        ShredValidation : ShredValidation
    });

})(jQuery);